import { render, staticRenderFns } from "./RuleTemplateTag.vue?vue&type=template&id=b8110e7a"
import script from "./RuleTemplateTag.vue?vue&type=script&lang=js"
export * from "./RuleTemplateTag.vue?vue&type=script&lang=js"
import style0 from "./RuleTemplateTag.vue?vue&type=style&index=0&id=b8110e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports